const VALIDATION_MESSAGES = {
	LAST_NAME_REQUIRED: 'Debe ingresar apellido.',
	NAME_REQUIRED: 'Debe ingresar nombre.',
	NAME_BLANK_SPACES: 'No se debe ingresar solo espacios en blanco en el nombre',
	LAST_NAME_BLANK_SPACES: 'No se debe ingresar solo espacios en blanco en el apellido',
	EMAIL_REQUIRED: 'Debe ingresar un correo electrónico.',
	PROFILE_REQUIRED: 'Debe seleccionar un grupo.',
	SERVICE_REQUIRED: 'Debe seleccionar al menos un ítem.'
};

const PROFILE_NAMES = {
	OPERADOR_SERVICIO_PRESUPUESTO: 'Operador de Servicio de Presupuesto',
	FISCALIZADOR: 'Fiscalizador',
	OPERADOR_DIRECCION_CONTABILIDAD: 'Operador de Dirección de Contabilidad',
	DIRECTOR_SA: 'Director de SA',
	OPERADOR_TESORERIA: 'Operador de Tesoreria',
	RESP_TRANSFERENCIA_FONDOS: 'Responsable de transferencia de fondos',
	JEFE_TESORERIA_SA: 'Jefe de Tesoreria de SA',
	JEFE_CONTABILIDAD_SA: 'Jefe de Contabilidad de SA',
	DELEGADO_FISCAL_SA: 'Delegado Fiscal de SA',
	CONTADOR_GENERAL: 'Contador General',
	OPERADOR_SUMINISTROS: 'Operador de Suministros',
	CONSULTA_POR_ORGANISMO: 'Consulta por Organismo'
};

// Listado de Perfiles que requieren selección de Servicios administrativos
const PROFILES_REQUIRING_SERVICE_SELECTION = [
    PROFILE_NAMES.OPERADOR_SERVICIO_PRESUPUESTO,
    PROFILE_NAMES.FISCALIZADOR,
    PROFILE_NAMES.OPERADOR_DIRECCION_CONTABILIDAD,
    PROFILE_NAMES.DIRECTOR_SA,
    PROFILE_NAMES.OPERADOR_TESORERIA,
    PROFILE_NAMES.RESP_TRANSFERENCIA_FONDOS,
    PROFILE_NAMES.JEFE_TESORERIA_SA,
    PROFILE_NAMES.JEFE_CONTABILIDAD_SA,
    PROFILE_NAMES.DELEGADO_FISCAL_SA,
    PROFILE_NAMES.CONTADOR_GENERAL,
    PROFILE_NAMES.OPERADOR_SUMINISTROS
];

// Funciones de validación personalizadas
const validateNotOnlySpaces = (message) => (value) => {
    !!value?.trim() ? undefined : message;
};

// Objetos de validación para react-hook-form
export const createValidationRules = () => ({
    lastName: {
        required: VALIDATION_MESSAGES.LAST_NAME_REQUIRED,
        validate: validateNotOnlySpaces(VALIDATION_MESSAGES.LAST_NAME_BLANK_SPACES)
    },
    name: {
        required: VALIDATION_MESSAGES.NAME_REQUIRED,
        validate: validateNotOnlySpaces(VALIDATION_MESSAGES.NAME_BLANK_SPACES)
    },
    email: {
        required: VALIDATION_MESSAGES.EMAIL_REQUIRED
    },
    profile: {
        required: VALIDATION_MESSAGES.PROFILE_REQUIRED
    }
});

export const isServiceSelectionRequired = (profileName) => {
	return PROFILES_REQUIRING_SERVICE_SELECTION.includes(profileName);
};

export const isOrganismSelectionRequired = (profileName) => {
    return profileName === PROFILE_NAMES.CONSULTA_POR_ORGANISMO;
};
